module.exports = __webpack_public_path__ + "img/welfare1.1a0f0110.png";